$(document).on('turbolinks:load', function() {
	$(document).on('click', '.see-more-description', function(){
		var id = $(this).attr("data-id");
		$('.see-more-description-' + id).addClass('hidden');
		$('.full-more-description-' + id).removeClass('hidden');
	});
});
